import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { FailedPayoutBannerContainer } from "../../FailedPayouts/components/FailedPayoutBannerContainer";
import { OutstandingBalanceBannerContainer } from "./OutstandingBalanceBannerContainer";

export function PaymentsListHeader() {
  return (
    <Stack
      sx={(theme) => ({
        justifyContent: "center",
        paddingX: theme.spacing(5),
        paddingTop: theme.spacing(6),
      })}
      data-testid="payments-header"
    >
      {/* only one of these banners is ever shown, which is why we haven't put in a horizontal scroll */}
      <FailedPayoutBannerContainer
        sourceUI="earnings-page"
        sx={(theme) => ({ marginBottom: theme.spacing(5) })}
      />
      <OutstandingBalanceBannerContainer sx={(theme) => ({ marginBottom: theme.spacing(5) })} />
      <Text semibold variant="h6">
        Payments
      </Text>
    </Stack>
  );
}
